export type Environment =
  | "sandbox"
  | "live"
  | "sandbox-staging"
  | "live-staging"
  | "local";

export enum ApiUrl {
  Live = "https://api.gocardless.com",
  Sandbox = "https://api-sandbox.gocardless.com",
  LiveStaging = "https://api-staging.gocardless.com",
  SandboxStaging = "https://api-sandbox-staging.gocardless.com",
  Local = "http://pay.gocardless.localhost:3002/enterprise",
}

export const EnvironmentApiUrl: Record<Environment, ApiUrl> = {
  ["live"]: ApiUrl.Live,
  ["sandbox"]: ApiUrl.Sandbox,
  ["live-staging"]: ApiUrl.LiveStaging,
  ["sandbox-staging"]: ApiUrl.SandboxStaging,
  ["local"]: ApiUrl.Local,
};
